import React, { useState } from 'react';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/Button';

import { declarationSignedFalse } from '../helpers/declarationFields';
import { choosePatient } from '../../../actions/appointmentsActions';
import OperatorForm from './operator';
import RenderPatient from '../common/renderPatient';
import ReferralInput from '../../components/refferal';

const defencerCategories = [
  'Учасник бойових дій',
  'Особа з інвалідністю внаслідок війни',
  'Учасник війни',
  'Член сім’ї загиблого (померлого) ветерана війни',
  'Член сім’ї загиблого (померлого) Захисника і Захисниці України',
];

const DefencerBenefitFields = ({ register, formErrors }) => (
  <div className="defencer-benefit-fields">
    <p className="defencer-benefit-fields__notice">
      Запис на цей слот можливий лише за наявності посвідчення.
    </p>
    <div className="appointment_field_container">
      <div className="appointment_field_title">
        <span>Категорія посвідчення</span>
        <span className="require">*</span>
      </div>
      <div className="appointment_field_wrapper">
        <select
          name="defencer_category"
          ref={register({ required: 'Оберіть категорію' })}
          defaultValue=""
          style={formErrors?.defencer_category ? { borderColor: 'red' } : {}}
        >
          <option value="" disabled>Оберіть категорію</option>
          {defencerCategories.map((category) => (
            <option key={category} value={category}>{category}</option>
          ))}
        </select>
        {formErrors?.defencer_category && (
          <p className="appointment_input-error">{formErrors.defencer_category.message}</p>
        )}
      </div>
    </div>
    <div className="appointment_field_container">
      <div className="appointment_field_title">
        <span>Серія та/або № посвідчення</span>
        <span className="require">*</span>
      </div>
      <div className="appointment_field_wrapper">
        <input
          type="text"
          name="defencer_document"
          placeholder="Серія та/або номер"
          maxLength={100}
          ref={register({ required: 'Вкажіть серію та/або номер посвідчення' })}
          style={formErrors?.defencer_document ? { borderColor: 'red' } : {}}
        />
        {formErrors?.defencer_document && (
          <p className="appointment_input-error">{formErrors.defencer_document.message}</p>
        )}
      </div>
    </div>
  </div>
);

const ChoosePatient = ({
  handleSubmit,
  onSubmit,
  patients,
  register,
  error,
  isOperator,
  operatorPatients,
  operatorPatientsLoaded,
  isOperatorChooseOtherPatient,
  updateAppointmentState,
  watch,
  control,
  timeSlot,
  referralNumber,
  setReferralNumber,
  formErrors,
  trigger,
  searchFilters,
  appointment,
  job,
}) => {
  
  const [isTelemedicine, setTelemedicine] = useState(false);
  const [registeringAnotherPatient, setRegisteringAnotherPatient] = useState(false);
  const [offerAgree, setOfferAgree] = useState(false);
  const onCheck = () => setTelemedicine((prevState) => !prevState);
  const onOfferAgreeCheck = () => setOfferAgree((prevState) => !prevState);
  
  if (isOperator)
    return (
      <OperatorForm
        watch={watch}
        control={control}
        register={register}
        handleSubmit={handleSubmit}
        error={error}
        onSubmit={onSubmit}
        operatorPatients={operatorPatients}
        operatorPatientsLoaded={operatorPatientsLoaded}
        isOperatorChooseOtherPatient={isOperatorChooseOtherPatient}
        updateAppointmentState={updateAppointmentState}
      />
    );
  
    patients.data = patients.data.filter((patient) => patient.id !== 0);
    
  if ((patients.loaded && (patients.data.length ?? 0) === 0) || registeringAnotherPatient) {
    return (
      <form onSubmit={handleSubmit(onSubmit)} className="confirmation_of_entry confirmed">
        <ReferralInput
          register={register}
          style={{ marginTop: '15px' }}
          timeSlot={timeSlot}
          referralNumber={referralNumber}
          setReferralNumber={setReferralNumber}
          formErrors={formErrors}
          error={error}
          trigger={trigger}
        />

        <input type="hidden" name="patient" value="other" ref={register} />
        <p className="appointment-auth-text">Кого ви хочете записати на прийом:</p>
        <div className="info_box declaration_false">
          <div className="user_info_box">
            {error && typeof error === 'string' && <span className="error">{error}</span>}
            {declarationSignedFalse.map(({ text, input, Component }) => (
              <Component key={text} text={text} error={error} input={input} register={register} control={control} />
            ))}
          </div>
        </div>
        {timeSlot.time_slot_type_system_name === 'defencer_benefit' && (
          <DefencerBenefitFields register={register} formErrors={formErrors} />
        )}
        
        {registeringAnotherPatient && (
          <p className="text-center">
            <Button 
              variant="outline-primary" 
              onClick={() => setRegisteringAnotherPatient(false)} 
              className="">
              Обрати пацієнта зі списку
            </Button>
          </p>
        )}
        
        {job?.medical_services_id && (
          <>
            <div className="medical_services_block" style={{ borderTop: "1px solid #d0e5f0", borderBottom: "none", paddingTop: "0.5rem" }}>
              <span>Назва мед.послуги</span>
              <p>{job?.medical_services_title}</p>
            </div>
            <div className="medical_services_block">
              <span>Вартість послуги</span>
              <p>{new Intl.NumberFormat('uk-UA', { maximumFractionDigits: 0 }).format(job?.medical_services_price)} грн.</p>
            </div>
            {job?.medical_services_fee > 0 && (
              <>
              <div className="medical_services_block">
                <span>Сервісний збір</span>
                <p>{new Intl.NumberFormat('uk-UA', { maximumFractionDigits: 0 }).format(job?.medical_services_fee)} грн.</p>
              </div>
              <div className="medical_services_block">
                <span>Сума до оплати</span>
                <p>{new Intl.NumberFormat('uk-UA', { maximumFractionDigits: 0 }).format(job?.medical_services_price + job?.medical_services_fee)} грн.</p>
              </div>
              </>
            )}
            <div className="medical_services_text">Після проведення оплати Ви отримуєте чек сервісного збору. Акт виконаних робіт Ви отримаєте від медичного закладу після надання послуг.</div>
          
            <label className="checkbox" style={{ 'border': 0, 'padding': '15px 0' }}>
              <input
                type="hidden"
                name="medical_service_id"
                value={job?.medical_services_id}
                ref={register({  })}
              />
              <input
                type="checkbox"
                name="offer_agree"
                checked={offerAgree}
                onChange={onOfferAgreeCheck}
                required
                ref={register({ required: true })}
              />
              <div className="checkbox__text" style={{ color: '#000' }}>
                Даю згоду на обробку персональних даних та погоджуюсь з <a href="/offer" target="_blank" rel="noopener noreferrer">Публічним договором</a> та <a href="/privacy" target="_blank" rel="noopener noreferrer">Політикою обробки персональних даних</a>.
              </div>
            </label>
          </>
        )}

        {timeSlot.time_slot_type_system_name === "paid" && !job?.medical_services_id && (
          <div className="paid_service_notice">
            <p>Увага! Цей час для платних надання платних послуг! Ціна буде сформована закладом в залежності від наданих послуг. Для деталей зверніться в реєстратуру.</p>
            <label className="checkbox" style={{ 'border': 0, 'padding': '15px 0' }}>
              <input
                type="checkbox"
                name="offer_agree"
                checked={offerAgree}
                onChange={onOfferAgreeCheck}
                required
                ref={register({ required: true })}
              />
              <div className="checkbox__text" style={{ color: '#000' }}>
                Я ознайомлений з інформацією про платну послугу та даю згоду на обробку персональних даних для отримання цієї послуги, а також погоджуюсь з <a href="/offer" target="_blank" rel="noopener noreferrer">Публічним договором</a> та <a href="/privacy" target="_blank" rel="noopener noreferrer">Політикою обробки персональних даних</a>.
              </div>
            </label>
          </div>
        )}

        <Button type="submit" variant="primary" className="submit-button">
          Підтверджую
        </Button>
      </form>
    );
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="confirmation_of_entry confirmed">
      <ReferralInput
        register={register}
        style={{ marginTop: '15px' }}
        timeSlot={timeSlot}
        referralNumber={referralNumber}
        setReferralNumber={setReferralNumber}
        formErrors={formErrors}
        error={error}
        trigger={trigger}
      />
      <p className="appointment-auth-text">Виберіть кого ви хочете записати на прийом:</p>
      <div className={patients.loaded ? null : 'confirmation_of_entry__patients-loading'}>
        {patients.loaded
          ? patients.data.map((patient) => (
              <RenderPatient
                key={patient.id}
                currentPatientId={
                  localStorage.getItem('patientId') && localStorage.getItem('patientId') > 0 ? +localStorage.getItem('patientId') : patients.data[0].id
                }
                register={register}
                patient={patient}
              />
            ))
          : 'Завантаження ...'}
      </div>
      {timeSlot.time_slot_type_system_name === 'defencer_benefit' && (
        <DefencerBenefitFields register={register} formErrors={formErrors} />
      )}
      
      {patients.loaded && (
        <p className="text-center">
          <Button 
            variant="outline-primary" 
            className="" 
            onClick={() => setRegisteringAnotherPatient(true)}>
            Записати іншого пацієнта на прийом
          </Button>
        </p>
      )}
      
      {error && typeof error === 'string' && (
        <div className="error_text" style={{ opacity: error ? 1 : 0, float: 'inherit', border: 0 }}>
          {error}
        </div>
      )}

      {job?.medical_services_id && (
        <>
          <div className="medical_services_block" style={{ borderTop: "1px solid #d0e5f0", borderBottom: "none", paddingTop: "0.5rem" }}>
            <span>Назва мед.послуги</span>
            <p>{job?.medical_services_title}</p>
          </div>
          <div className="medical_services_block">
            <span>Вартість послуги</span>
            <p>{new Intl.NumberFormat('uk-UA', { maximumFractionDigits: 0 }).format(job?.medical_services_price)} грн.</p>
          </div>
          {job?.medical_services_fee > 0 && (
            <>
            <div className="medical_services_block">
              <span>Сервісний збір</span>
              <p>{new Intl.NumberFormat('uk-UA', { maximumFractionDigits: 0 }).format(job?.medical_services_fee)} грн.</p>
            </div>
            <div className="medical_services_block">
              <span>Сума до оплати</span>
              <p>{new Intl.NumberFormat('uk-UA', { maximumFractionDigits: 0 }).format(job?.medical_services_price + job?.medical_services_fee)} грн.</p>
            </div>
            </>
          )}
          <div className="medical_services_text">Після проведення оплати Ви отримуєте чек сервісного збору.<br/>Акт виконаних робіт Ви отримаєте від медичного закладу після надання послуг.</div>
        
          <label className="checkbox" style={{ 'border': 0, 'padding': '15px 0' }}>
            <input
              type="hidden"
              name="medical_service_id"
              value={job?.medical_services_id}
              ref={register({  })}
            />
            <input
              type="checkbox"
              name="offer_agree"
              checked={offerAgree}
              onChange={onOfferAgreeCheck}
              required
              ref={register({ required: true })}
            />
            <div className="checkbox__text" style={{ color: '#000' }}>
              Даю згоду на обробку персональних даних та погоджуюсь з <a href="/offer" target="_blank" rel="noopener noreferrer">Публічним договором</a> та <a href="/privacy-data" target="_blank" rel="noopener noreferrer">Політикою обробки персональних даних</a>.
            </div>
          </label>
        </>
      )}

      {timeSlot.is_telemedicine && (
        <label className="checkbox" style={{ 'border': 0, 'padding': '5px 0' }}>
          <input
            type="checkbox"
            name="is_video_conference"
            checked={isTelemedicine}
            ref={register({  })}
            onChange={onCheck}
          />
          <div className="checkbox__text" style={{ color: '#000' }}>
            Я хочу провести <b>прийом Онлайн</b> (телеконсультація за допомогою відео зв'язку - посилання на Онлайн консультацію буде доступно в Вашому кабінеті в розділі "Записи на прийом" за 10 хв до початку прийому).
          </div>
        </label>
      )}

      {timeSlot.time_slot_type_system_name === "paid" && !job?.medical_services_id && (
        <>
          <div className="paid_service_notice screening-banner" style={{ padding: '10px' }}>
            <p style={{  fontWeight: 'normal', fontSize: '16px', textAlign: 'center' }}><strong>⚠️ Важливо:</strong> Обраний час для надання платних послуг, деталі за <strong>телефонами реєстратури</strong>.</p>
          </div>
          <label className="checkbox" style={{ 'border': 0, 'padding': '15px 0' }}>
            <input
              type="checkbox"
              name="offer_agree"
              checked={offerAgree}
              onChange={onOfferAgreeCheck}
              required
              ref={register({ required: true })}
            />
            <div className="checkbox__text" style={{ color: '#000' }}>
              Я ознайомлений з інформацією про платну послугу і розумію що ціна буде сформована закладом під час відвідування закладу.
            </div>
          </label>
        </>
      )}

      <Button type="submit" variant="primary" className="submit-button" disabled={!patients.loaded}>
        Підтверджую
      </Button>
    </form>
  );
};

const mapDispatchToProps = { choosePatient };

export default connect(null, mapDispatchToProps)(ChoosePatient);
